import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addSalesInvoice = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_sales_invoice'
    '/api/resource/Sales Invoice',
    body
  );
  return data;
});
export const updateSalesInvoice = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_sales_invoice',
    `/api/resource/Sales Invoice/${id}`,
    body
  );
  return data;
});
export const getSalesInvoices = catchAsync(
  async (searchKey, searchText, currentLang) => {
    // console.log(searchKey,"searchKey");

    let baseUrl = `/api/resource/Sales Invoice?fields=["name", "outstanding_amount","customer", "status", "posting_date", "base_grand_total", "docstatus"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&order_by=name desc`;
    if (searchText) {
      if (searchKey === 'posting_date') {
        // &filters={"is_return":0}
        baseUrl += `&filters=[["is_return", "=", 0],["posting_date","Between",["${searchText}","${searchText}"]]]`;
      } else {
        baseUrl += `&filters=[["is_return", "=", 0],["${searchKey}","like","%${searchText}%"]]`;
      }
    } else {
      baseUrl += `&filters={"is_return":0}`;
    }
    const { data } = await axiosInstance.get(
      baseUrl
      // `/api/method/technoerp.services.get_sales_invoices?page=${pageCount}&limit=10&is_return=0`
      // `/api/method/technoerp.services.get_sales_invoices?limit_start=10&limit_page_length=10&page=${pageCount}&filters={"is_return":0}`
      // '/api/method/technoerp.services.get_customer_sales_invoices'
    );
    return data;
  }
);
export const getCreditNotes = catchAsync(async (currentLang) => {
  // let baseUrl = `/api/resource/Sales Invoice?fields=["name", "outstanding_amount","customer", "status", "posting_date", "base_grand_total", "docstatus"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&order_by=name desc`;
  const { data } = await axiosInstance.get(
    `/api/resource/Sales Invoice?fields=["name", "outstanding_amount","customer", "status", "posting_date", "base_grand_total", "docstatus"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&order_by=name desc&filters={"is_return":1}`
    // `/api/method/technoerp.services.get_sales_invoices?limit_start=10&limit_page_length=10&page=${pageCount}&filters={"is_return":1}`
    // `/api/method/technoerp.services.get_sales_invoices?page=${pageCount}&limit=10&is_return=1`
    // '/api/method/technoerp.services.get_customer_sales_invoices'
  );
  return data;
});

export const getPDF = catchAsync(async ({ type, name, lang, format }) => {
  // console.log(type, name, lang, format);

  const data = await axiosInstance.get(
    // `/api/method/technoerp.services.downloadpdf?type=${type}&name=${name}&lang=${lang}&format=Sales Auditing Voucher`,
    `/api/method/technoerp.services.downloadpdf?type=${type}&name=${name}&_lang=${lang}&format=${
      format === undefined ? '' : format
    }&no_letterhead=0`,
    { responseType: 'blob' }
  );

  console.log(data, 'dataddddddd');
  return data;
});

export const creditSalesInvoice = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_credit_note?source_name=${id}`
  );
  return data;
});

export const createPaymentEntryQuick = catchAsync(async (values) => {
  console.log(values, 'values');

  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.create_payment_entry_quick?invoice_number=${values?.sales_invoice}&paid_amount=${values?.amount}&mode_of_payment=${values?.mode_of_payment}`
  );
  return data;
});

export const getLastInvoices = catchAsync(async (patientId, practitionerId) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_patient_invoices?patient=${patientId}&practitioner=${practitionerId}`
  );
  return data;
});
export const getLinkedEntries = catchAsync(async (name) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_linked_entries?type=Sales Invoice&name=${name}`
  );
  return data;
});

export const getVatTax = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_vat_tax'
  );
  return data;
});
export const getSalesInvoiceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_sales_invoice?salesinvoice=${id}`
    `/api/resource/Sales Invoice/${id}`
  );
  return data;
});
export const deleteSalesInvoice = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Sales Invoice/${id}`
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Sales Invoice`
  );
  return data;
});

export const submitSalesInvoice = catchAsync(async (name) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.submit_sales_invoice?sales_invoice=${name}`
  );
  return data;
});
export const unlinkEntries = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.unlink_entries`,
    body
  );
  return data;
});

export const cancelSalesInvoice = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    // `/api/resource/Insurance Payor Contract/${record}`
    `/api/method/technoerp.services.cancel_record?record=${record}&document=Sales Invoice`
  );
  return data;
});

export const getPartyDetailsCustomer = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_party_details?party_type=Customer&party=${id}&type=Sales Invoice`
  );
  return data;
});
export const AddbulkAction = catchAsync(async (type, action, selectNames) => {
  const { data } = await axiosInstance.post(
    // `/api/method/technoerp.services.bulk_action?type=Sales Invoice&action=${action}&names=${JSON.stringify(selectNames)}`
    `/api/method/technoerp.services.bulk_action?type=${type}&action=${action}&names=${JSON.stringify(
      selectNames
    )}`
  );
  return data;
});
export const AddcreditNote = catchAsync(async (name) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=SI CN&source=${name}`
  );
  return data;
});
export const getPrintFormat = catchAsync(async (doc_type) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Print Format?filters=[["doc_type", "=", "${doc_type}"],["disabled", "=", 0]]&order_by=modified%20desc`
  );
  return data;
});
export const submitToZatca = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    // `/api/method/technoerp.services.submit_to_zatca?invoice=${id}`
    `/api/method/technoerp.services.submit_to_zatca?invoice=${id}`
  );
  return data;
});
export const downloadZatca = catchAsync(
  async ({ type, name, lang, format }) => {
    const data = await axiosInstance.get(
      `/api/method/technoerp.services.download_zatca_pdf?invoice=${name}&format=${format}&lang=${lang}&no_letterhead=0`,
      { responseType: 'blob' }
    );
    console.log(data, 'dataddddddd');
    return data;
  }
);
export const downloadZatcaXml = catchAsync(async (id) => {
  const data = await axiosInstance.get(
    `/api/method/technoerp.services.download_zatca_xml?invoice=${id}`,
    {
      // responseType: 'blob',
      responseType: 'text',
    }
  );
  return data;
});
export const getZatcaDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_zatca_details?invoice=${id}`
  );
  return data;
});
export const getSalesOrder = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.map_reference?target=SO SI&source=${id}`
  );
  return data;
});
